/**
 * Cart Drawer - AJAX cart with debounce, toast, reliable refresh
 */
(function () {
  'use strict';

  var cartDrawer = document.getElementById('cartDrawer');
  var cartToggle = document.getElementById('cartToggle');
  var cartDrawerClose = document.getElementById('cartDrawerClose');
  var overlay = document.getElementById('overlay');
  var cartCount = document.getElementById('cartCount');

  if (!cartDrawer) return;

  function openCartDrawer() {
    cartDrawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (overlay) overlay.addEventListener('click', function () {
    closeCartDrawer();
    if (window.closeMobileMenu) window.closeMobileMenu();
    if (window.closeSearchPopup) window.closeSearchPopup();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCartDrawer(); });

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      if (!res.ok) throw new Error('İstek başarısız: ' + res.status);
      return res.json();
    });
  }

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
  }

  function cartChangeUrl() {
    return (window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js';
  }

  function cartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js';
  }

  function addToCart(variantId, quantity) {
    return fetchJSON(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
    });
  }

  function updateCartItem(key, quantity) {
    return fetchJSON(cartChangeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    });
  }

  function applyDrawerHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newDrawer = doc.getElementById('cartDrawer');
    if (newDrawer) {
      cartDrawer.innerHTML = newDrawer.innerHTML;
      if (newDrawer.getAttribute('style')) cartDrawer.setAttribute('style', newDrawer.getAttribute('style'));
    }
    var newCount = doc.getElementById('cartCount');
    if (newCount && cartCount) {
      cartCount.textContent = newCount.textContent;
      cartCount.dataset.count = newCount.dataset.count;
    }
    cartDrawer.classList.remove('is-loading');
    rebindDrawer();
  }

  function refreshCart() {
    var sectionId = cartDrawer.dataset.sectionId || 'cart-drawer';
    var sectionUrl = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);

    return fetch(sectionUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        if (html.indexOf('id="cartDrawer"') === -1 && html.indexOf("id='cartDrawer'") === -1) {
          return fetch(window.location.pathname).then(function (res) { return res.text(); }).then(applyDrawerHtml);
        }
        applyDrawerHtml(html);
      })
      .catch(function () {
        cartDrawer.classList.remove('is-loading');
      });
  }

  function rebindDrawer() {
    var newClose = document.getElementById('cartDrawerClose');
    if (newClose) newClose.addEventListener('click', closeCartDrawer);

    var newNote = document.getElementById('cartNote');
    if (newNote) {
      var noteTimer;
      newNote.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch(cartUpdateUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: newNote.value })
          });
        }, 600);
      });
    }

    var newUpsell = document.getElementById('cdUpsellToggle');
    if (newUpsell) {
      newUpsell.addEventListener('change', function () {
        cartDrawer.classList.add('is-loading');
        if (newUpsell.checked) addToCart(newUpsell.dataset.variantId, 1).then(refreshCart);
        else if (newUpsell.dataset.cartKey) updateCartItem(newUpsell.dataset.cartKey, 0).then(refreshCart);
      });
    }

    var track = document.getElementById('cdRecsTrack');
    var prev = document.getElementById('cdRecsPrev');
    var next = document.getElementById('cdRecsNext');
    if (track && prev && next) {
      prev.addEventListener('click', function () { track.scrollBy({ left: -200, behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: 200, behavior: 'smooth' }); });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add-btn, .pp__bs-add');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    var originalHTML = btn.innerHTML;
    btn.innerHTML = '<span class="spinner"></span>';

    addToCart(variantId, 1)
      .then(function () {
        if (window.showToast) window.showToast('Ürün sepete eklendi!', 'success');
        return refreshCart();
      })
      .then(function () { openCartDrawer(); })
      .catch(function () {
        if (window.showToast) window.showToast('Ürün eklenemedi, tekrar deneyin.', 'error');
      })
      .finally(function () {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      });
  });

  var productForm = document.getElementById('productForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var variantId = formData.get('id');
      var quantity = parseInt(formData.get('quantity'), 10) || 1;
      var addBtn = document.getElementById('addToCartBtn');

      if (addBtn) {
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        addBtn.dataset.original = addBtn.innerHTML;
        addBtn.innerHTML = '<span class="spinner"></span> Ekleniyor...';
      }

      addToCart(variantId, quantity)
        .then(function () {
          if (window.showToast) window.showToast('Ürün sepete eklendi!', 'success');
          return refreshCart();
        })
        .then(function () { openCartDrawer(); })
        .catch(function () {
          if (window.showToast) window.showToast('Ürün eklenemedi, tekrar deneyin.', 'error');
        })
        .finally(function () {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.innerHTML = addBtn.dataset.original || 'Sepete Ekle';
          }
        });
    });
  }

  var debounceTimer = null;

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.cd .cd__qty-btn, .cd .cd__item-remove');
    if (!qtyBtn) return;
    e.preventDefault();

    var key = qtyBtn.dataset.key;
    if (!key) return;

    cartDrawer.classList.add('is-loading');

    if (qtyBtn.classList.contains('cd__item-remove')) {
      updateCartItem(key, 0).then(refreshCart);
      return;
    }

    var action = qtyBtn.dataset.action;
    var item = qtyBtn.closest('.cd__item');
    var qtyDisplay = item ? item.querySelector('.cd__qty-num') : null;
    var currentQty = qtyDisplay ? parseInt(qtyDisplay.textContent, 10) : 1;

    if (action === 'increase') currentQty++;
    if (action === 'decrease') currentQty = Math.max(0, currentQty - 1);
    if (qtyDisplay) qtyDisplay.textContent = currentQty;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      updateCartItem(key, currentQty).then(refreshCart);
    }, 400);
  });

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.quantity-selector button');
    if (!qtyBtn || qtyBtn.closest('.cd')) return;

    var wrapper = qtyBtn.closest('.quantity-selector');
    var input = wrapper ? wrapper.querySelector('input') : null;
    if (!input) return;

    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 99;

    if (qtyBtn.dataset.action === 'increase' && val < max) val++;
    if (qtyBtn.dataset.action === 'decrease' && val > min) val--;
    input.value = val;
  });

  var noteEl = document.getElementById('cartNote');
  if (noteEl) {
    var noteTimer;
    noteEl.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch(cartUpdateUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteEl.value })
        });
      }, 600);
    });
  }

  var recsTrack = document.getElementById('cdRecsTrack');
  var recsPrev = document.getElementById('cdRecsPrev');
  var recsNext = document.getElementById('cdRecsNext');
  if (recsTrack && recsPrev && recsNext) {
    recsPrev.addEventListener('click', function () { recsTrack.scrollBy({ left: -160, behavior: 'smooth' }); });
    recsNext.addEventListener('click', function () { recsTrack.scrollBy({ left: 160, behavior: 'smooth' }); });
  }

  var upsellToggle = document.getElementById('cdUpsellToggle');
  if (upsellToggle) {
    upsellToggle.addEventListener('change', function () {
      cartDrawer.classList.add('is-loading');
      if (upsellToggle.checked) addToCart(upsellToggle.dataset.variantId, 1).then(refreshCart);
      else if (upsellToggle.dataset.cartKey) updateCartItem(upsellToggle.dataset.cartKey, 0).then(refreshCart);
    });
  }

  window.cartDrawer = { open: openCartDrawer, close: closeCartDrawer, refresh: refreshCart, add: addToCart };
})();
